import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, _params) => ({
    image: {
        width: '100%',
        position: 'relative',
        '& img': {
            objectFit: 'cover',
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
        },
        paddingTop: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
        },
        minHeight: (() => {
            if (_params.newStyle) {
                if (_params.isShowMore) {
                    switch (_params.linksCount) {
                        case 2:
                            return '150px';
                        case 3:
                            return '200px';
                        default:
                            return '200px';
                    }
                }
                return _params.linksCount === 1 ? '100px' : '200px';
            }
            return '200px';
        })(),
    },
    fullWidth: {
        [theme.breakpoints.up('sm')]: {
            // desktop image to be full width and it to fill container
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
        },
    },
    desktopImageContainer: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    mobileImageContainer: {
        display: 'block',
        paddingTop: _params.isShowMore && _params.newStyle ? '0' : '100%',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    displayDesktopImage: {
        display: 'block',
    },
    squareImage: {
        // Use padding top to make image square
        paddingTop: _params.isShowMore && _params.newStyle ? '0' : '100%',
        [theme.breakpoints.up('sm')]: {
            // Use padding top to make image square
            paddingTop: '50%',
        },
    },
}));
export default useStyles;
